package uk.co.nickthecoder.kyd

import uk.co.nickthecoder.glok.event.KeyEvent

interface Director : Customisable {

    fun onActStarting(act: Act) {}
    fun onActStarted(act: Act) {}
    fun onActEnded(act: Act) {}

    /**
     * Called before all [Behaviour.tick] are called the actors in the act.
     */
    fun preTick(seconds: Float) {}

    /**
     * Called after all [Behaviour.tick] are called the actors in the act.
     */
    fun postTick(seconds: Float) {}

    fun onKeyPressed(keyEvent: KeyEvent) {}

    fun onKeyReleased(keyEvent: KeyEvent) {}

}

object NoDirector : Director
